interface BillingToggleProps {
  isAnnual: boolean
  onChange: (isAnnual: boolean) => void
}

export function BillingToggle({ isAnnual, onChange }: BillingToggleProps) {
  return (
    <div className="flex items-center justify-center gap-2 font-['DM_Sans']">
      <span
        className={`text-sm font-medium ${
          !isAnnual ? 'text-white' : 'text-[rgba(128,128,128)]'
        }`}
      >
        Monthly
      </span>
      <button
        onClick={() => onChange(!isAnnual)}
        className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors ${
          isAnnual ? 'bg-[rgba(255,255,255,0.4)]' : 'bg-[rgba(128,128,128,0.3)]'
        }`}
        role="switch"
        aria-checked={isAnnual}
      >
        <span
          className={`${
            isAnnual ? 'translate-x-8' : 'translate-x-1'
          } inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-200 ease-in-out`}
        />
      </button>
      <div className="flex items-center gap-4">
        <span
          className={`text-sm font-medium ${
            isAnnual ? 'text-white ' : 'text-[rgba(128,128,128)] '
          }`}
        >
          Annual
        </span>
        <span className="inline-flex items-center rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700">
          Save 17%
        </span>
      </div>
    </div>
  )
}
